import { StickerCard } from "@/components/sticker-card/StickerCard.tsx";
import usePermissions from "@/hooks/use-permissions.hook.ts";
import { ApiFormParticipantStatus } from "@/types/forms/form.types.ts";
import { ApiPerformanceReviewRespondView } from "@/types/performance-review.types.ts";
import { ApiPermission } from "@/types/role.types.ts";
import { ApiFeatureType } from "@/types/subscription.types.ts";
import { Button, ButtonLink, FullScreenPage, Stack, Title } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export const PerformanceReviewCompleted = ({
  review,
  onEditAnswers,
}: {
  review: ApiPerformanceReviewRespondView;
  onEditAnswers?: () => void;
}) => {
  const { t } = useTranslation();
  const { isFeatureEnabled, canIEdit } = usePermissions();
  const isCompletedParticipant = review.reviewer_status == ApiFormParticipantStatus.completed;

  const canViewReviews =
    isFeatureEnabled(ApiFeatureType.talent_performance_reviews) &&
    canIEdit(ApiPermission.performance_reviews_module);
  const canEditAnswers = review.can_edit_results && !!onEditAnswers;
  return (
    <>
      <FullScreenPage contentSize={"lg"}>
        <Stack direction={"horizontal"} items={"center"}>
          <StickerCard
            title={review.title}
            caption={review.description || undefined}
            emoji={review.emoji || undefined}
          />
          <Stack className={"pl-18"} gap={"lg"}>
            <Title
              size={"lg"}
              header={
                isCompletedParticipant
                  ? t("performance_review:responses_submitted_title")
                  : t("performance_review:review_completed_title")
              }
              caption={
                isCompletedParticipant
                  ? t("performance_review:review_completed_description")
                  : t("performance_review:review_closed_description")
              }
            ></Title>
            <Stack direction={"horizontal"} gap={"sm"}>
              {canEditAnswers && (
                <Button variant={"primary"} size={"lg"} onClick={onEditAnswers}>
                  {t("scorecards:change_answers")}
                </Button>
              )}
              <ButtonLink
                variant={canEditAnswers ? "secondary" : "primary"}
                size={"lg"}
                href={canViewReviews ? "/my-feedback/requests" : "/"}
              >
                {t("common:close")}
              </ButtonLink>
            </Stack>
          </Stack>
        </Stack>
      </FullScreenPage>
    </>
  );
};
